var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"land-info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"land-info-column-container"},[_c('div',{staticClass:"info-desc"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.salesCard.shablon_section_info_zakon)}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.salesCard.shablon_section_info_desc)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }